import apiClient from 'apiClient';
import { AxiosPromise } from 'axios';
import { Task } from './Task';

const getAll = (apiPrefix: string): AxiosPromise<Task[]> => {
  return apiClient.get(`${apiPrefix}/tasks/`);
};

export default getAll;
